// How a leave type is shown. Unpaid leave is called Leave Without Pay (LWP): the days are taken off the month's pay.
export const leaveTypeLabel = (type) => (type === 'UNPAID' ? 'Leave Without Pay (LWP)' : type);
